import React from "react";

const Address = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="256"
      height="256"
    >
      <g data-name="Layer 2" fill="#000000" className="color000 svgShape">
        <path
          fill="#cdd1ff"
          d="M25.11,29.17H20.45v-8.6h4.66a4.3,4.3,0,0,1,4.3,4.3h0A4.3,4.3,0,0,1,25.11,29.17Z"
          className="colorc6f9b9 svgShape"
        ></path>
        <path
          fill="#302f2f"
          d="M2.68 23.72l-.1-.08a1 1 0 0 1 0-1.48c1.8-1.43 5-2.48 9.11-2.93l.22 2c-3.59.4-6.61 1.35-8.07 2.49A1 1 0 0 1 2.68 23.72zM16 31c-5.79 0-10.92-1.24-13.38-3.16a1 1 0 0 1 0-1.49l.09-.07a1 1 0 0 1 1.2 0C5.71 27.71 10.13 29 16 29c7.94 0 13-2.37 13-4 0-1.38-3.38-3.18-9-3.79l.22-2C25.42 19.79 31 21.61 31 25 31 28.9 23.27 31 16 31z"
          className="color302f2f svgShape"
        ></path>
        <path
          fill="#cdd1ff"
          d="M24.63,11.44c-.36,3.58-5,10-7.3,13l0,0V2.12h0C21.55,2.88,25.07,7.17,24.63,11.44Z"
          className="colorc6f9b9 svgShape"
        ></path>
        <path
          fill="#302f2f"
          d="M16,26.05a2.64,2.64,0,0,1-2.08-1C12,22.64,8.8,18.27,7.29,14.6a1,1,0,0,1,.61-1.33h0a1,1,0,0,1,1.23.55c1.47,3.58,4.9,8.1,6.39,10a.64.64,0,0,0,.51.25h0a.62.62,0,0,0,.49-.24l.08-.09c4.14-5.37,6.79-10,7-12.38C24,7.71,20.93,3.78,17.17,3.1S9.74,5.28,8.71,9a1,1,0,0,1-1.1.7h0a1,1,0,0,1-.81-1.26C8,4.24,11.9,1,16.05,1a8,8,0,0,1,1.48.14c4.79.87,8.57,5.73,8.09,10.41-.38,3.77-4.87,10.06-7.5,13.48l-.08.1a2.55,2.55,0,0,1-2,.93Z"
          className="color302f2f svgShape"
        ></path>
        <path
          fill="#302f2f"
          d="M16.05,12.71A3.74,3.74,0,1,1,19.79,9,3.74,3.74,0,0,1,16.05,12.71Zm0-5.47A1.74,1.74,0,1,0,17.79,9,1.74,1.74,0,0,0,16.05,7.24Z"
          className="color302f2f svgShape"
        ></path>
      </g>
    </svg>
  );
};

export default Address;
